import * as React from "react";
import { useEffect } from "react";
import "../proposols/step1/proposol.css";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { set_info1 } from "../../Redux/action";
import { Col, Form, Input, Button, Collapse } from "antd/lib";
import axios from "axios";
import Proposerdisplay from "./InfoDisplay/SelfProposerDisplay";
import { OwnerDetails } from "./OwnerDetails";
import { SelfPropDetail } from "./PropDetails/SelfPropDetail";
import { SpousePropDetail } from "./PropDetails/SpousePropDetail";
import { Son1PropDetail } from "./PropDetails/Son1PropDetail";
import { Son2PropDetail } from "./PropDetails/Son2PropDetail";
import { Daughter1PropDetail } from "./PropDetails/Daugh1PropDetail";
import { Daughter2PropDetail } from "./PropDetails/Daugh2PropDetails";
import { FatherPropDetail } from "./PropDetails/FatherPropDetail";
import { MotherPropDetail } from "./PropDetails/MotherPropDetails";
import { FatherInLawPropDetail } from "./PropDetails/FatherInLawDetail";
import { MotherInLawPropDetail } from "./PropDetails/MotherInLawDetails";

function ProposerDetail({ showStep2, setShowStep2, Ref2 }) {
  // console.log('showStep2',showStep2)
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { Panel } = Collapse;
  const [formLayout] = useState("vertical");
  const dispatch = useDispatch();
  const history = useHistory();
  const reg = useSelector((state) => state?.healthdetail?.healthnum);
  const OwnerInfo = useSelector((state) => state?.addressdetail?.info1);
  const PersonsDetail = useSelector(
    (state) => state?.healthdetail?.famdetail?.healthdetail
  );
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ShowSelfDisplay, setShowSelfDisplay] = useState(false);
  const [ShowSpouseDisplay, setShowSpouseDisplay] = useState(false);
  const [Son1PropDisplay, setSon1PropDisplay] = useState(false);
  const [Son2PropDisplay, setSon2PropDisplay] = useState(false);
  const [Daugh1PropDisplay, setDaugh1PropDisplay] = useState(false);
  const [Daugh2PropDisplay, setDaugh2PropDisplay] = useState(false);
  const [FatherPropDisplay, setFatherPropDisplay] = useState(false);
  const [MotherPropDisplay, setMotherPropDisplay] = useState(false);
  const [FatherInLawPropDisplay, setFatherInLawPropDisplay] = useState(false);
  const [MotherInLawPropDisplay, setMotherInLawPropDisplay] = useState(false);
  const [isAllPresent, setIsAllPresent] = useState(false);

  // console.log('OwnerInfo',OwnerInfo)

  const [activeKey, setActiveKey] = useState(["1"]);

  useEffect(() => {
    FetchStates();
    ShowCollapse();
  }, [ShowSelfDisplay, showStep2]);

  useEffect(() => {
    const allPersonsInOwnerInfo = PersonsDetail?.every((detail) =>
      OwnerInfo?.hasOwnProperty(detail.relationship)
    );
    setIsAllPresent(allPersonsInOwnerInfo);
    console.log(allPersonsInOwnerInfo);
  }, [PersonsDetail, OwnerInfo]);
  // console.log('isAllPresent',isAllPresent)

  const FetchStates = () => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    const url = `${BASEURL}states`;
    const config = {
      headers: {
        Authorization: "Bearer " + reg.token,
      },
    };
    axios
      .get(url, config)
      .then((res) => {
        const resp = res?.data?.data;
        const statesArray = Object.keys(resp).map((id) => ({
          id,
          label: resp[id],
        }));
        setOptions(statesArray);
      })
      .catch((err) => {
        console.log(err?.response);
      });
  };
  const ShowCollapse = () => {
    if (ShowSelfDisplay === true) {
      setActiveKey(["2"]);
    }
  };
  const onFinish = (values) => {
    setLoading(true);
    // console.log(values)
    var data = {
      Owner: values?.fullName,
      Mobile: values?.MobileNumber,
      Email: values?.email,
      bloodGroup: values?.bloodGroup,
      height: values?.height,
      inches: values?.inches,
      weight: values?.weight,
      Address: values?.address,
      City: values?.city,
      State: values.state,
      Pincode: values?.pincode,
    };
    // console.log(data)
    dispatch(set_info1(data));
    setTimeout(() => {
      setLoading(false);
      // setShowStep2(true)
      // Ref2.current?.scrollIntoView({ behavior: "smooth" });
      //history.push("/step2");
    }, 500);
  };

  const ProceedTo = () => {
    setShowStep2(true);
    Ref2.current?.scrollIntoView({ behavior: "smooth" });
  };
  // console.log(PersonsDetail)
  const onChange = (keys) => {
    console.log(keys);
    setActiveKey(keys);
  };
  return (
    <>
      <div>
        {PersonsDetail?.length > 1 ? (
          <>
            {PersonsDetail?.some(
              (person) => person?.relationship === "Self"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel header="SELF DETAILS" key="1" className="posp-pannel">
                    <SelfPropDetail
                      setShowSelfDisplay={setShowSelfDisplay}
                      ShowSelfDisplay={ShowSelfDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            {PersonsDetail?.some(
              (person) => person?.relationship === "Spouse"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel
                    header="SPOUSE DETAILS"
                    key="2"
                    className="posp-pannel"
                  >
                    <SpousePropDetail
                      setShowSpouseDisplay={setShowSpouseDisplay}
                      ShowSpouseDisplay={ShowSpouseDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            {PersonsDetail?.some(
              (person) => person?.relationship === "Son1"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel header="SON 1 DETAILS" key="3" className="posp-pannel">
                    <Son1PropDetail
                      setSon1PropDisplay={setSon1PropDisplay}
                      Son1PropDisplay={Son1PropDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            {PersonsDetail?.some(
              (person) => person?.relationship === "Son2"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel header="SON 2 DETAILS" key="4" className="posp-pannel">
                    <Son2PropDetail
                      setSon2PropDisplay={setSon2PropDisplay}
                      Son2PropDisplay={Son2PropDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            {PersonsDetail?.some(
              (person) => person?.relationship === "Daughter1"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel
                    header="DAUGHTER 1 DETAILS"
                    key="5"
                    className="posp-pannel"
                  >
                    <Daughter1PropDetail
                      setDaugh1PropDisplay={setDaugh1PropDisplay}
                      Daugh1PropDisplay={Daugh1PropDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            {PersonsDetail?.some(
              (person) => person?.relationship === "Daughter2"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel
                    header="DAUGHTER 2 DETAILS"
                    key="6"
                    className="posp-pannel"
                  >
                    <Daughter2PropDetail
                      setDaugh2PropDisplay={setDaugh2PropDisplay}
                      Daugh2PropDisplay={Daugh2PropDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            {PersonsDetail?.some(
              (person) => person?.relationship === "Father"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel
                    header="FATHER DETAILS"
                    key="7"
                    className="posp-pannel"
                  >
                    <FatherPropDetail
                      setFatherPropDisplay={setFatherPropDisplay}
                      FatherPropDisplay={FatherPropDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            {PersonsDetail?.some(
              (person) => person?.relationship === "Mother"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel
                    header="MOTHER DETAILS"
                    key="8"
                    className="posp-pannel"
                  >
                    <MotherPropDetail
                      setMotherPropDisplay={setMotherPropDisplay}
                      MotherPropDisplay={MotherPropDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            {PersonsDetail?.some(
              (person) => person?.relationship === "FatherInLaw"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel
                    header="FATHER IN LAW DETAILS"
                    key="9"
                    className="posp-pannel"
                  >
                    <FatherInLawPropDetail
                      setFatherInLawPropDisplay={setFatherInLawPropDisplay}
                      FatherInLawPropDisplay={FatherInLawPropDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            {PersonsDetail?.some(
              (person) => person?.relationship === "MotherInLaw"
            ) ? (
              <>
                <Collapse
                  className="posp-collapse"
                  activeKey={activeKey}
                  onChange={onChange}
                >
                  <Panel
                    header="MOTHER IN LAW DETAILS"
                    key="10"
                    className="posp-pannel"
                  >
                    <MotherInLawPropDetail
                      setMotherInLawPropDisplay={setMotherInLawPropDisplay}
                      MotherInLawPropDisplay={MotherInLawPropDisplay}
                      isAllPresent={isAllPresent}
                    />
                  </Panel>
                </Collapse>
              </>
            ) : null}
            <Col span={24}>
              <Form.Item style={{ textAlign: "center" }}>
                {isAllPresent ? (
                  <Button
                    loading={loading}
                    onClick={ProceedTo}
                    style={{ background: "#293890", border: "#293890" }}
                    type="primary"
                    htmlType="submit"
                  >
                    Proceed to Medical Details
                  </Button>
                ) : null}
              </Form.Item>
            </Col>
          </>
        ) : (
          <OwnerDetails
            showStep2={showStep2}
            setShowStep2={setShowStep2}
            Ref2={Ref2}
            isAllPresent={isAllPresent}
          />
        )}
      </div>
    </>
  );
}

export { ProposerDetail };
